<template>
  <div class="desk-frame contact-page cellosign-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">
        הגשה לוועדת חריגים
      </h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="iframe-container">
          <button class="back-button" @click="onBack" type="button">
            <span class="arrow">‹</span>
            <span>חזור ליומן הניתוחים</span>
          </button>

          <div v-if="errorMessage" class="error-container">
            <p class="error-message">{{ errorMessage }}</p>
            <button class="bt_blue" @click="retry" type="button">
              נסה שנית
            </button>
          </div>

          <div v-else-if="!iframeUrl" class="loader-container">
            <vue-loaders-ball-clip-rotate
              color="#30448d"
              scale="2"
            ></vue-loaders-ball-clip-rotate>
          </div>

          <iframe
            v-else
            :src="iframeUrl"
            width="100%"
            height="700vh"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { sendCelloSign } from "../api/api-quatro.js";
import { getHash } from "../utilities/hash.js";

export default {
  name: "SurgSpecialApproval",
  components: {
    DashboardHeader,
    Menu,
    MenuDesktop
  },
  data() {
    return {
      iframeUrl: "",
      formaData: null,
      errorMessage: ""
    };
  },
  computed: {
    ...mapState(["activeDoctor"]),
    ...mapGetters(["MENU_ACTIVE"])
  },
  methods: {
    onBack() {
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.go(-1);
        return;
      }
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    async getSurgeryInfo() {
      try {
        const res = await this.$API.getSurgeryInfo(this.$route.params.id);
        const { patient, surgery, doctor } = res.message;

        let birthDate;
        if (patient.birthDate) {
          birthDate = this.$moment(patient.birthDate, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          );
        }

        let startDate;
        if (surgery.start_date) {
          startDate = this.$moment(
            surgery.start_date,
            "YYYY-MM-DDTHH:mm:ss"
          ).format("DD/MM/YYYY");
        }

        this.formaData = {
          surgery_id: `${this.$route.params.id}`,
          name: doctor.heb_name,
          firstname: patient.firstName,
          lastname: patient.lastName,
          passport: patient.passport,
          start_date: startDate,
          surgery_name: surgery.name,
          hospitalization: surgery.hospitalization,
          birthDate: birthDate,
          FTzpH2DJdnUe: "",
          reason: ""
        };
      } catch (error) {
        console.error("Error getting surgery info", error);
      }
    },
    async getIframeUrl() {
      this.errorMessage = "";
      this.iframeUrl = "";

      let req = {
        doctor_name: this.activeDoctor.name,
        doccode: this.activeDoctor.license,
        mdbid: this.activeDoctor.id
      };

      if (this.formaData) {
        req = { ...req, ...this.formaData };
      }

      try {
        const response = await sendCelloSign(req, "exception-committee-iframe");
        const url = response?.data?.session?.client_url;
        if (!url) {
          this.errorMessage = "לא התקבל קישור מהשרת, נסה שנית מאוחר יותר";
          return;
        }
        this.iframeUrl = url;
      } catch (error) {
        this.errorMessage = "אירעה שגיאה בטעינת הטופס, נסה שנית מאוחר יותר";
        console.error("Error sending consent cellosign", error);
      }
    },
    async retry() {
      if (this.$route.params.id) {
        await this.getSurgeryInfo();
      }
      await this.getIframeUrl();
    }
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSurgeryInfo();
    }
    await this.getIframeUrl();
  }
};
</script>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  gap: 20px;
}
.error-message {
  color: #e74c3c;
  font-size: 18px;
  font-weight: 600;
}
</style>
